import type { ReactNode } from 'react';

const RECENT_HOURS = 48;

export function isRecentActivity(iso: string | null | undefined, hours = RECENT_HOURS): boolean {
  if (!iso) return false;
  return Date.now() - new Date(iso).getTime() < hours * 3600000;
}

/** Pulsing dot when “live” or recent; muted dot otherwise. */
export function ActivityHeartbeatDot({
  active,
  variant = 'emerald',
}: {
  /** When true, shows ping animation (recent activity or processing). */
  active: boolean;
  variant?: 'emerald' | 'amber';
}) {
  const fill = variant === 'amber' ? 'bg-amber-400' : 'bg-emerald-500';
  const ping = variant === 'amber' ? 'bg-amber-400' : 'bg-emerald-400';
  return (
    <span className="relative flex h-2 w-2 shrink-0" aria-hidden>
      {active ? (
        <span className={`absolute inline-flex h-full w-full rounded-full ${ping} opacity-60 animate-ping`} />
      ) : null}
      <span
        className={`relative inline-flex h-2 w-2 rounded-full ${active ? fill : 'bg-[var(--vscode-border-primary)]'}`}
      />
    </span>
  );
}

export function CandidateActivityStrip({
  children,
  dotActive,
  dotVariant = 'emerald',
  compact = false,
}: {
  children: ReactNode;
  dotActive: boolean;
  dotVariant?: 'emerald' | 'amber';
  /** Tighter padding for dense candidate profile layout */
  compact?: boolean;
}) {
  return (
    <div
      className={`flex flex-wrap items-center gap-2 rounded-lg border border-[var(--vscode-border-primary)] bg-[var(--vscode-bg-elevated)] px-3 text-xs sm:text-[13px] ${
        compact ? 'py-1.5' : 'py-2.5'
      }`}
      role="status"
    >
      <ActivityHeartbeatDot active={dotActive} variant={dotVariant} />
      <div className="min-w-0 flex-1 vscode-text-secondary leading-snug">{children}</div>
    </div>
  );
}
